import { FileText, Palette, Sparkles, Download } from "lucide-react";

const HowItWorksSection = () => {
  const steps = [
    {
      icon: FileText,
      number: "01",
      title: "Paste Your Title",
      description: "Enter your YouTube video title or describe your video idea. Our AI understands context and intent.",
    },
    {
      icon: Palette,
      number: "02",
      title: "Choose Style & Emotion",
      description: "Select from dozens of styles and emotions. From exciting to educational, we've got you covered.",
    },
    {
      icon: Sparkles,
      number: "03",
      title: "Generate with AI",
      description: "Our AI creates multiple thumbnail variations optimized for maximum click-through rate.",
    },
    {
      icon: Download,
      number: "04",
      title: "Download & Upload",
      description: "Pick your favorite, download in high resolution, and upload directly to YouTube.",
    },
  ];

  return (
    <section className="section-padding relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-secondary/20 to-background" />

      <div className="container-custom relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-sm font-semibold text-brand-purple uppercase tracking-wider mb-4 block">
            How It Works
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            Create Thumbnails in{" "}
            <span className="gradient-text">4 Simple Steps</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            No design skills required. Generate professional thumbnails faster than ever before.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative group"
            >
              {/* Connection Line (hidden on mobile) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[60%] w-[80%] h-px bg-gradient-to-r from-border to-transparent" />
              )}

              <div className="relative p-6 rounded-2xl bg-card border border-border hover:border-primary/50 transition-all duration-300 card-shine h-full">
                {/* Number Badge */}
                <div className="absolute -top-3 -right-3 w-12 h-12 rounded-xl gradient-bg flex items-center justify-center text-sm font-bold text-primary-foreground shadow-lg">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-secondary flex items-center justify-center mb-5 group-hover:bg-primary/10 transition-colors">
                  <step.icon className="w-7 h-7 text-brand-purple" />
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold mb-3">{step.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
